<div class="modal-header">
    <h4>Close Out Email Recipients</h4>
</div>
<div class="modal-body">
    <div *ngFor="let data of formData.emailToList" style="margin-bottom: 10px;">
        <div class="row" *ngIf="(data.signedOffSelected != null && data.signedOffSelected?.HQContactID != -2) || data.isCollected" >
            <input type="checkbox" style="width:25px;height:25px;display:flex;margin-left: 15px;" [(ngModel)]="data.selectedEmployees">
            <span style="display:flex;margin-left:15px;" *ngIf="data.signedOffSelected?.HQContactID != -1">{{data.signedOffSelected?.Display}}</span>
            <span style="display:flex;margin-left:15px;" *ngIf="data.signedOffSelected?.HQContactID == -1 || data.isCollected">{{data.firstName}} {{data.lastName}}</span>
        </div>
    </div>
    <div *ngIf="!disableEmailOnComplete">
        <label>Additional Email Distribution</label>
        <input type="text" class="form-control" [(ngModel)]="formData.emailDistribution" (change)="emailRegexCheck()" [ngClass]="{'is-invalid': emailIsInvalid}" />
        <div class="input-group" style="margin-top: 10px;margin-bottom:10px;">
            <ng-select (change)="checkEmail()" [(ngModel)]="formData.selectedEmail" style="min-width: 250px;">
                <ng-option *ngFor="let data of fullEmailListFiltered" [value]="data">
                    {{data.Display}} - {{data.Email}}
                </ng-option>
            </ng-select>
            <span class="input-group-btn">
                <button type="button" class="btn btn-primary" (click)="addToEmailList()" [disabled]="formData.selectedEmail == null || emailExist">
                    Add
                </button>
            </span>
            <span *ngIf="emailExist" style="color:red;">Email already added</span>
        </div>
    </div>
    <div *ngIf="formData.emailCCList.length > 0 && !disableEmailOnComplete">
        <ul *ngFor="let data of formData.emailCCList; let i = index">
            <li>{{data.Email}} <span *ngIf="data.NewAdded" style="color:red;cursor: pointer;" (click)="removeEmail(i)">remove</span></li>
        </ul>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-text-primary" (click)="cancelClicked()">Close</button>
    <button type="button" class="btn btn-success" (click)="completeClicked()">Complete</button>
</div>